



























































































import { Vue, Prop, Component } from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import DateFormat from '@/shared/utils/date-format';
import CardExpandable from '@/shared/card/card-expandable.component.vue';
import TextFieldBasicColumn from '@/shared/text-field/text-field-column-basic.component.vue';
import ContractHistoryTimelineItem from './contract-history-timeline-item.component.vue';
import ContractHistory from '../../../domain/contract/entity/contract-version-history.entity';
import Header from './header.json';

@Component({
  components: {
    MainButton,
    ContractHistoryTimelineItem,
    CardExpandable,
    TextFieldBasicColumn,
  },
  filters: {
    dayMonthYearTime(date: string): string {
      return DateFormat.fullDateAndTime(date);
    },
    dayMonthYear(date: string): string {
      return DateFormat.timestampToLocal(date);
    },
  },
})
export default class ContractHistoryTimeline extends Vue {
  @Prop({
    required: true,
  })
  private contractHistory!: ContractHistory;

  @Prop({
    required: false,
    default: true,
  })
  showBackButton!: boolean;

  header = Header;

  private go(path: string): void {
    this.$router.push(path);
  }
}
